<template>
  <div class="min-h-screen bg-white ">
    <!-- Sayfa İçeriği -->
    <div class="relative">
      <!-- Üst Kısım Dekoratif Arka Plan -->
      <div
        class="absolute inset-x-0 top-0 h-80 bg-gradient-to-b from-orange-50 to-white overflow-hidden"
      >
        <!-- Dalga Efekti SVG -->
        <div class="absolute inset-0">
          <svg
            class="absolute bottom-0 w-full h-48 fill-white"
            viewBox="0 0 1920 240"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0,192L60,181.3C120,171,240,149,360,149.3C480,149,600,171,720,192C840,213,960,235,1080,229.3C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            ></path>
          </svg>
        </div>

        <!-- Dekoratif Daireler -->
        <div
          class="absolute -top-24 -left-20 w-96 h-96 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
        ></div>
        <div
          class="absolute -top-24 -right-20 w-96 h-96 bg-orange-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
        ></div>
      </div>

      <!-- Ana İçerik -->
      <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <!-- Breadcrumb -->
        <slot name="breadcrumb" />

        <!-- Başlık kısmı -->
        <div class="mb-8 text-center lg:text-left">
          <h1 class="text-3xl font-bold text-gray-900 mb-2">
            <slot name="title">Hesap Sayfası</slot>
          </h1>
          <p class="text-sm text-gray-600">
            <slot name="description">Hesap bilgilerinizi yönetin</slot>
          </p>
        </div>

        <div class="lg:grid lg:grid-cols-4 gap-8">
          <!-- Sol Menü -->
          <div class="col-span-1 mb-6 lg:mb-0">
            <PartialsAccountMenu
              class="sticky top-4 bg-white rounded-xl shadow-sm"
            ></PartialsAccountMenu>
          </div>

          <!-- Sağ İçerik -->
          <div class="col-span-3 space-y-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
